// ===================================================================
// File: client/src/scenes/loans/LoanScheduleTable.jsx (unchanged imports)
// ===================================================================
import React from "react";
import { Box, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "@apollo/client";
import { GET_REPAYMENT_SCHEDULE } from "../../graphql/loans";
import { formatDisplayDate } from "../../utils/date";

const LoanScheduleTable = () => {
  const theme = useTheme();
  const { data, loading, error } = useQuery(GET_REPAYMENT_SCHEDULE);

  const columns = [
    { field: "loanApplicationId", headerName: "Loan ID", flex: 0.8 },
    {
      field: "dueDate",
      headerName: "Due Date",
      flex: 1,
      valueFormatter: ({ value }) => formatDisplayDate(value),
    },
    { field: "principalDue", headerName: "Principal Due", flex: 1 },
    { field: "principalPaid", headerName: "Principal Paid", flex: 1 },
    { field: "interestDue", headerName: "Interest Due", flex: 1 },
    { field: "interestPaid", headerName: "Interest Paid", flex: 1 },
    { field: "status", headerName: "Status", flex: 1 },
  ];

  if (error) return <p>Error: {error.message}</p>;

  return (
    <Box height="75vh" sx={{
      "& .MuiDataGrid-root": { border: "none" },
      "& .MuiDataGrid-cell": { borderBottom: "none" },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: theme.palette.background.alt,
        color: theme.palette.secondary[100],
        borderBottom: "none",
      },
      "& .MuiDataGrid-virtualScroller": {
        backgroundColor: theme.palette.primary.light,
      },
      "& .MuiDataGrid-footerContainer": {
        backgroundColor: theme.palette.background.alt,
        color: theme.palette.secondary[100],
        borderTop: "none",
      },
      "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
        color: `${theme.palette.secondary[200]} !important`,
      },
    }}>
      <DataGrid
        loading={loading}
        rows={data?.userLoanRepaymentSchedule || []}
        getRowId={(row) => row.id}
        columns={columns}
      />
    </Box>
  );
};

export default LoanScheduleTable;